<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Supplier Status</label>
              <v-select :clearable="true" name="status" placeholder="" v-model="filters['status']" label="name"
                :options="supplier_status_list" :reduce="option => option.value" multiple />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="RM SUPPLIERS">
          <template slot="actions">
            <div class="flex">

            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="suppliers-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="rm_suppliers"
              @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="20%" sort-key="company_name">COMPANY NAME</vs-th>
                <vs-th width="20%" sort-key="account_number">ACCOUNT NUMBER</vs-th>
                <vs-th width="10%">CURRENCY</vs-th>
                <vs-th width="15%" sort-key="is_approved" class="">SUPPLIER STATUS</vs-th>
                <vs-th width="15%" class="">SUPPLIER PORTAL ACCOUNT</vs-th>
                <vs-th width="10%">NO OF UNAPPROVED SITES</vs-th>
                <vs-th width="10%" v-can="'edit-supplier'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickSupplierView(data[indextr].id)" :key="indextr"
                  v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].account_number">
                    {{ data[indextr].account_number || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].currency.code">
                    <vs-chip style="border-radius: 0" size="small" class="ml-2" transparent color="#7952B3">
                      {{ data[indextr].currency.code || 'N/A' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <vs-chip transparent>
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].is_supplier_activated">
                    <vs-chip transparent v-if="data[indextr].is_supplier_activated === 1" color="primary">
                      Activated
                    </vs-chip>
                    <vs-chip transparent v-if="data[indextr].is_supplier_activated === 0" color="danger">
                      Suspended
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].no_of_unapproved_sites }}
                  </vs-td>


                  <vs-td v-can="'edit-supplier'">
                    <div class="vx-row">
                      <vx-tooltip text="View / Edit" position="left">
                        <vs-button class="ml-3" @click="onClickSupplierView(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const SupplierRepository = RepositoryFactory.get('supplier')
import { defaultPagination, perPageList } from "@/constants/config";

export default {
  name: 'ManageSuppliers',
  data() {
    return {
      rm_suppliers: [],
      departments: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      supplier_status_list: [
        { name: 'SAQ Pending', value: 1 },
        { name: 'Pending Approval', value: 2 },
        { name: 'Approved', value: 3 },
        { name: 'Not Approved', value: 4 },
        { name: 'On Hold', value: 5 },
      ],
      tenant_id: ''
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [Filter],
  async mounted() {
    this.tenant_id = this.$route.params.id
  },
  methods: {
    async refreshData() {
      this.loadRmSuppliers()
    },

    async loadRmSuppliers() {
      await this.$vs.loading({
        container: '#suppliers-table',
        scale: 0.45
      })
      const { data } = await SupplierRepository.get(this.tenant_id, this.page, this.filterQuery, this.perPage, this.sort)
      this.rm_suppliers = data.data
      this.meta = data.meta
      this.$vs.loading.close('#suppliers-table > .con-vs-loading')
    },
    openConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },

    acceptAlert() {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position: 'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },
    async onClickSupplierView(id) {
      // const url = `/pages/tenants/${this.tenant_id}/suppliers/${id}`;
      // const newTab = window.open(url, '_blank');
      // newTab.focus();
      this.$router.push({ path: `/pages/tenants/${this.tenant_id}/suppliers/${id}` })
    },
    filterQueryUpdate() {
      this.loadRmSuppliers()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadRmSuppliers()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadRmSuppliers()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },

  },
  watch: {
    page() {
      this.loadRmSuppliers()
    },
    perPage() {
      this.loadRmSuppliers()
    }
  }
}
</script>
